import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import {
  MissionForm,
  MissionFormSubmitHelpers,
} from "../../components/MissionForm";
import { useCreateMission } from "../../hooks/useCreateMission";
import { MissionSchema } from "../../schemas/mission.schema";
import { useGoBack } from "@/common/hooks/useGoBack";
import useUserPermissions from "@/common/hooks/useUserPermissions";

const MissionsCreate = () => {
  const goBack = useGoBack();
  const { hasUserPermission, isUserPermissionsPending } = useUserPermissions();
  const canCreateMission =
    isUserPermissionsPending ||
    hasUserPermission("Admin::Tmais::Missions::Create");

  const { mutate: createMission, isPending } = useCreateMission({
    onSuccess: () => goBack({ fallback: "/tmais-missions" }),
  });

  const handleSubmit = (
    values: MissionSchema,
    helpers: MissionFormSubmitHelpers,
  ) => {
    createMission(values, { onError: helpers.onError });
  };

  return (
    <ErrorMessageWrapper
      className="h-[calc(100vh-100px)]"
      statusCode={canCreateMission ? 200 : 403}
    >
      <div className="flex flex-col h-[calc(100vh-100px)]">
        <div className="flex-1 overflow-y-auto pr-4 pb-10">
          <MissionForm
            mode="create"
            onSubmit={handleSubmit}
            isSubmitting={isPending}
            onCancel={() => goBack({ fallback: "/tmais-missions" })}
          />
        </div>
      </div>
    </ErrorMessageWrapper>
  );
};

export default MissionsCreate;
